<template>
  <fragment>
    <SummaryGroup>
      <div class="row mb-4">
        <div class="col-md-4">
          <SummaryItem label="Geschlecht" :value="gender" />
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-4 mb-4 mb-md-0">
          <SummaryItem label="Vorname" :value="firstname" />
        </div>
        <div class="col-md-8">
          <SummaryItem label="Nachname" :value="lastname" />
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-4 mb-md-0" :class="{ 'mb-4': availability }">
          <SummaryItem label="Telefon" :value="phone" />
        </div>
        <div v-if="availability" class="col-md-8">
          <SummaryItem label="Erreichbarkeit" :value="availability" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 mb-4 mb-md-0">
          <SummaryItem label="E-Mail-Adresse" :value="email" />
        </div>
        <div class="col-md-8">
          <SummaryItem label="Geburtsdatum" :value="formattedDateOfBirth" />
        </div>
      </div>
    </SummaryGroup>
    <SummaryGroup>
      <div class="row mb-4">
        <div class="col-md-12">
          <SummaryItem label="Straße, Nr." :value="street" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-1 mb-4 mb-md-0">
          <SummaryItem label="PLZ" :value="postalCode" />
        </div>
        <div class="col-md-3 mb-4 mb-md-0">
          <SummaryItem label="Stadt" :value="city" />
        </div>
        <div class="col-md-8">
          <SummaryItem label="Land" :value="country" />
        </div>
      </div>
    </SummaryGroup>
  </fragment>
</template>

<script>
import format from 'date-fns/format';

export default {
  name: 'PersonalSummary',
  inject: ['formContext'],
  props: {
    gender: {
      type: String,
      required: true,
    },
    firstname: {
      type: String,
      required: true,
    },
    lastname: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    availability: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      required: true,
    },
    dateOfBirth: {
      type: String,
      required: true,
    },
    street: {
      type: String,
      required: true,
    },
    postalCode: {
      type: String,
      required: true,
    },
    city: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedDateOfBirth() {
      return format(Date.parse(this.dateOfBirth), 'dd.MM.yyyy');
    },
  },
};
</script>
